import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import InventorySearchForm from './OMInventorySearchForm';
const allTabs = [
  {
    ID: 1,
    Title: 'Item'
  },
  {
    ID: 2,
    Title: 'Lot'
  }
];
const OMInventory = (props) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
    }
  }, []);
    return (
    <div>
       <TabPanel key={selectedTabIndex} onOptionChanged={onTabSelectionChanged} selectedIndex={selectedTabIndex}>
        {allTabs.map((m, i) => (
          <Item key={i} title={m.Title}>
            <InventorySearchForm selectedTab={m.Title} />
          </Item>
        ))}
      </TabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMInventory);